import { ChartsLabelCustomMarkProps } from '@mui/x-charts-pro';

const EkonomiskAnalysLegendLine: React.FC<ChartsLabelCustomMarkProps> = ({
  className,
  color,
}) => {
  return (
    <svg viewBox="0 0 24 4">
      <line
        className={className}
        x1={0}
        y1={2}
        x2={24}
        y2={2}
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  );
};

export default EkonomiskAnalysLegendLine;
